import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: 2
  },
  label: {
    padding: '-10px 0px',
    margin: '-10px 0px'
  },
  tooltip: {
    margin: theme.spacing(0, 1),
    backgroundColor: theme.colorPalette.green_75,
    fontSize: 10
  },
  button: {
    height: 24
  }
});

export default makeStyles(styles);
